<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title primary-title class="grey lighten-3">{{ title }}</v-card-title>
        <v-card-text class="py-0">
          <v-container>
            <span v-if="text">¿{{ text }}?</span>
            <span class="font-weight-bold" v-if="item"><br>{{ item }}</span>
            <slot/>
          </v-container>
        </v-card-text>
        <v-card-actions> 
          <v-spacer></v-spacer>
          <v-btn text class="mr-4" @click="close()">Cancelar</v-btn>
          <v-btn class="white--text" :color="colorButton" @click="$emit('confirm')">{{ textButton }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "Confirmation",
    props: {
      value: Boolean,
      title: { type: String, default: 'Confirmar' },
      text: { type: String, default: 'Está seguro de que desea realizar esta acción' },
      item: { type: String, default: '' },
      textButton: { type: String, default: 'Eliminar' },
      colorButton: { type: String, default: 'deep-orange' },         
    },
    data: () => ({
      dialog: false
    }),
    watch: {
      value (val) {
        this.dialog = val
      }
    },
    methods: {
      close (){
        this.dialog = false
        this.$emit('input', null)
        this.$emit('close')
      }
    }
  }
</script>

